module.exports = __webpack_public_path__ + "img/6.9a155d3e.svg";